// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9972) return "js/chunk.npm-async-@tauri-apps.317f56fc.js";
	if (chunkId === 5284) return "js/chunk.5284.2e00ba83.js";
	if (chunkId === 421) return "js/chunk.npm-async-html2canvas.6cc430e3.js";
	if (chunkId === 9141) return "js/chunk.npm-async-@shikijs.d52dd925.js";
	if (chunkId === 955) return "js/chunk.npm-shiki.18d89ed0.js";
	if (chunkId === 1006) return "js/chunk.npm-async-pdf-lib.90b9adfa.js";
	if (chunkId === 2394) return "js/chunk.npm-async-@pdf-lib.22b8a29e.js";
	if (chunkId === 8385) return "js/chunk.npm-async-pako.41b4bd0a.js";
	if (chunkId === 1571) return "js/chunk.npm-async-mermaid.4d11b438.js";
	if (chunkId === 3405) return "js/chunk.npm-async-@mermaid-js.13d8859b.js";
	if (chunkId === 4922) return "js/chunk.npm-async-lodash-es.e4825a04.js";
	if (chunkId === 1105) return "js/chunk.npm-async-langium.19cb1e6a.js";
	if (chunkId === 531) return "js/chunk.npm-async-chevrotain.16dcdd0f.js";
	if (chunkId === 9810) return "js/chunk.npm-async-vscode-languageserver-types.55d31fb6.js";
	if (chunkId === 4511) return "js/chunk.npm-async-@chevrotain.85807e58.js";
	if (chunkId === 6041) return "js/chunk.npm-async-chevrotain-allstar.c18f28f7.js";
	if (chunkId === 7966) return "js/chunk.npm-async-dagre-d3-es.578d73b6.js";
	if (chunkId === 9809) return "js/chunk.npm-async-cytoscape.76cfa4d3.js";
	if (chunkId === 1342) return "js/chunk.npm-async-layout-base.1edf5d3a.js";
	if (chunkId === 1770) return "js/chunk.npm-async-cytoscape-fcose.7d63368e.js";
	if (chunkId === 1618) return "js/chunk.1618.ce0a34e2.js";
	if (chunkId === 6902) return "js/chunk.npm-async-@dotlottie.188cd6bc.js";
	if (chunkId === 6215) return "js/chunk.6215.d62f16db.js";
	if (chunkId === 7592) return "js/chunk.7592.b9e5a1ce.js";
	if (chunkId === 5226) return "js/chunk.5226.45d8a9b4.js";
	if (chunkId === 52) return "js/chunk.52.fb8eb4c7.js";
	if (chunkId === 944) return "js/chunk.944.1d08afa7.js";
	if (chunkId === 3674) return "js/chunk.3674.6c1e85a2.js";
	if (chunkId === 5627) return "js/chunk.5627.260487c8.js";
	if (chunkId === 5585) return "js/chunk.npm-async-@choochmeque.016bce40.js";
	if (chunkId === 8849) return "js/chunk.8849.a4bc65ac.js";
	if (chunkId === 7192) return "js/chunk.7192.2081e186.js";
	if (chunkId === 1191) return "js/chunk.1191.f19ea9da.js";
	if (chunkId === 7033) return "js/chunk.7033.853607ac.js";
	if (chunkId === 6464) return "js/chunk.6464.db9a8e45.js";
	if (chunkId === 666) return "js/chunk.666.16c3eaa8.js";
	if (chunkId === 2676) return "js/chunk.2676.bf920c6f.js";
	if (chunkId === 9589) return "js/chunk.9589.6e6b8a83.js";
	if (chunkId === 5571) return "js/chunk.npm-async-mdast-util-to-hast.ed0b9c8c.js";
	if (chunkId === 4413) return "js/chunk.4413.3d9c95a5.js";
	if (chunkId === 9853) return "js/chunk.9853.8c456d51.js";
	if (chunkId === 4047) return "js/chunk.4047.e6c6bc3c.js";
	if (chunkId === 1558) return "js/chunk.1558.dbd85c23.js";
	if (chunkId === 984) return "js/chunk.984.4d35c595.js";
	if (chunkId === 9530) return "js/chunk.9530.8cae4268.js";
	if (chunkId === 4357) return "js/chunk.4357.1ce78c8b.js";
	if (chunkId === 7087) return "js/chunk.npm-async-jsonrepair.5fd21b98.js";
	if (chunkId === 4890) return "js/chunk.4890.4d9e5b83.js";
	if (chunkId === 7486) return "js/chunk.7486.1abc8bff.js";
	if (chunkId === 5877) return "js/chunk.5877.7801c38f.js";
	if (chunkId === 6866) return "js/chunk.6866.432865f4.js";
	if (chunkId === 3095) return "js/chunk.npm-async-canvas-confetti.d2556860.js";
	if (chunkId === 6080) return "js/chunk.6080.accd99af.js";
	if (chunkId === 9429) return "js/chunk.9429.23c8acea.js";
	if (chunkId === 9630) return "js/chunk.9630.99962199.js";
	if (chunkId === 1100) return "js/chunk.1100.b6ffbe5e.js";
	if (chunkId === 1539) return "js/chunk.1539.9d4844eb.js";
	if (chunkId === 5883) return "js/chunk.5883.424fc927.js";
	if (chunkId === 6402) return "js/chunk.6402.e47f73a7.js";
	if (chunkId === 3501) return "js/chunk.3501.9fd1b2da.js";
	if (chunkId === 1986) return "js/chunk.1986.cc6aa0c1.js";
	if (chunkId === 4128) return "js/chunk.4128.6499af63.js";
	if (chunkId === 7011) return "js/chunk.7011.47344e8b.js";
	if (chunkId === 7228) return "js/chunk.7228.c5f2bebc.js";
	if (chunkId === 2541) return "js/chunk.2541.5b981ef5.js";
	if (chunkId === 9325) return "js/chunk.npm-async-@pique-so.70e75f1d.js";
	if (chunkId === 8916) return "js/chunk.npm-async-rrweb.bf11af97.js";
	if (chunkId === 2239) return "js/chunk.npm-async-@xyflow.6e4bf6ec.js";
	if (chunkId === 4323) return "js/chunk.4323.6aca722e.js";
	if (chunkId === 4676) return "js/chunk.npm-async-chrono-node.781b170f.js";
	if (chunkId === 3941) return "js/worker.7df71952.js";
	// return url for filenames based on template
	return undefined;
};